var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-6 w-6 rounded-full flex justify-center items-center",class:_vm.properties.backgroundColor},[(_vm.properties.component)?_c(_vm.properties.component,{tag:"component",staticClass:"text-white"}):_c('span',{staticClass:"w-6"},[_vm._v(" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }